import api from './api';
import { Ticket } from '../types';

export const ticketService = {
  async getTickets(filters?: {
    status?: string;
    category?: string;
    assignedTo?: string;
  }): Promise<{ tickets: Ticket[]; count: number }> {
    const response = await api.get('/tickets', { params: filters });
    return response.data;
  },

  async getTicket(id: string): Promise<Ticket> {
    const response = await api.get(`/tickets/${id}`);
    return response.data.ticket;
  },

  async createTicket(data: {
    title: string;
    description: string;
    category: string;
    clientCompany?: string;
  }): Promise<Ticket> {
    const response = await api.post('/tickets', data);
    return response.data.ticket;
  },

  async approveTicket(id: string): Promise<Ticket> {
    const response = await api.post(`/tickets/${id}/approve`);
    return response.data.ticket;
  },

  async rejectTicket(id: string, reason: string): Promise<Ticket> {
    const response = await api.post(`/tickets/${id}/reject`, { reason });
    return response.data.ticket;
  },

  async updateTicket(id: string, data: Partial<Ticket>): Promise<Ticket> {
    const response = await api.put(`/tickets/${id}`, data);
    return response.data.ticket;
  },

  async deleteTicket(id: string): Promise<void> {
    await api.delete(`/tickets/${id}`);
  },

  async purgeOrphanedTickets(): Promise<{ deleted: number; message: string }> {
    const response = await api.delete('/tickets/orphaned');
    return response.data;
  },

  async getTicketMessages(id: string) {
    const response = await api.get(`/tickets/${id}/messages`);
    return response.data.messages;
  },

  async sendMessage(id: string, message: string, attachments: string[] = []) {
    const response = await api.post(`/tickets/${id}/messages`, { message, attachments });
    return response.data.message;
  },

  async closeTicketAsEndUser(id: string): Promise<Ticket> {
    const response = await api.post(`/tickets/${id}/close`);
    return response.data.ticket;
  },

  async requestReopenTicket(id: string): Promise<Ticket> {
    const response = await api.post(`/tickets/${id}/reopen`);
    return response.data.ticket;
  },

  async assignToSelf(id: string): Promise<Ticket> {
    const response = await api.post(`/tickets/${id}/assign-to-self`);
    return response.data.ticket;
  },

  async escalateTicket(id: string): Promise<Ticket> {
    const response = await api.post(`/tickets/${id}/escalate`);
    return response.data.ticket;
  },

  async getTicketActivity(id: string) {
    const response = await api.get(`/tickets/${id}/activity`);
    return response.data.activities;
  }
}; 